import EventStyle from '../types/EventStyle'

import Colors from '~/client/src/shared/theme.module.scss'

export function getSharedEventStyles(): React.CSSProperties {
  return {
    color: Colors.neutral50,
    backgroundColor: Colors.neutral100,
    border: `1px dashed ${Colors.neutral50}`,
  }
}

export default class EventStyleCssAdapter {
  public constructor(private eventStyle: EventStyle) {}

  public getStyles() {
    const {
      textColor: color,
      backgroundColor,
      border,
      outline,
    } = this.eventStyle.styles

    const styles: React.CSSProperties = {
      color,
      backgroundColor,
    }

    if (border?.thickness) {
      styles.border = `${border.thickness}px ${border.strokeStyle} ${border.color}`
    }

    if (outline?.thickness) {
      styles.outline = `${outline.thickness}px ${outline.strokeStyle} ${outline.color}`
    }

    return styles
  }
}
